export default "__VITE_PUBLIC_ASSET__5de419ec__"